/*
 * Enums
 * */
export var Event;
(function (Event) {
    Event["ACCOUNT_INFO"] = "ACCOUNT_INFO";
    Event["ERROR"] = "ERROR";
    Event["CHART"] = "CHART";
    Event["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
    Event["PRICES"] = "PRICES";
    Event["ASSET_GROUPS"] = "ASSET_GROUPS";
    Event["TICK"] = "TICK";
    Event["CURRENT_PRICES"] = "CURRENT_PRICES";
    Event["BONDS"] = "BONDS";
    Event["ORDER_OPENED"] = "ORDER_OPENED";
    Event["ORDER_CLOSED"] = "ORDER_CLOSED";
    Event["ORDER_UPDATED"] = "ORDER_UPDATED";
    Event["BALANCE_UPDATE"] = "BALANCE_UPDATE";
    Event["PENDING_ORDER_OPENED"] = "PENDING_ORDER_OPENED";
    Event["PENDING_ORDER_ACTIVATED"] = "PENDING_ORDER_ACTIVATED";
    Event["PENDING_ORDER_CANCELED"] = "PENDING_ORDER_CANCELED";
    Event["PENDING_ORDER_UPDATED"] = "PENDING_ORDER_UPDATED";
    Event["SIGNALS"] = "SIGNALS";
    Event["SIGNAL"] = "SIGNAL";
    Event["EXPIRED_SIGNALS"] = "EXPIRED_SIGNALS";
    Event["MARKET_STATE_CHANGED"] = "MARKET_STATE_CHANGED";
})(Event || (Event = {}));
export var Command;
(function (Command) {
    Command["LOGIN"] = "LOGIN";
    Command["SUBSCRIBE"] = "SUBSCRIBE";
    Command["UNSUBSCRIBE"] = "UNSUBSCRIBE";
    Command["OPEN_TRADE"] = "OPEN_TRADE";
    Command["CLOSE_TRADE"] = "CLOSE_TRADE";
    Command["CLOSE_ALL_TRADES"] = "CLOSE_ALL_TRADES";
    Command["MODIFY_TRADE"] = "MODIFY_TRADE";
    Command["GET_CHART"] = "GET_CHART";
    Command["CANCEL_PENDING_ORDER"] = "CANCEL_PENDING_ORDER";
})(Command || (Command = {}));
export var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["INVALID_CREDENTIALS"] = "Not Authorized";
    ErrorMessages["INSUFFICIENT_MARGIN"] = "Insufficient Margin";
    ErrorMessages["NOTHING_CHANGED"] = "Nothing Changed";
    ErrorMessages["MARKET_CLOSED"] = "Market Closed";
})(ErrorMessages || (ErrorMessages = {}));
export var Direction;
(function (Direction) {
    Direction[Direction["UNDEFINED"] = 0] = "UNDEFINED";
    Direction[Direction["UP"] = 1] = "UP";
    Direction[Direction["DOWN"] = 2] = "DOWN";
})(Direction || (Direction = {}));
export var KeyLevelType;
(function (KeyLevelType) {
    KeyLevelType[KeyLevelType["UNDEFINED"] = 0] = "UNDEFINED";
    KeyLevelType[KeyLevelType["SUPPORT"] = 1] = "SUPPORT";
    KeyLevelType[KeyLevelType["RESISTANCE"] = 2] = "RESISTANCE";
})(KeyLevelType || (KeyLevelType = {}));
var LineType;
(function (LineType) {
    LineType[LineType["UNDEFINED"] = 0] = "UNDEFINED";
    LineType[LineType["SUPPORT"] = 1] = "SUPPORT";
    LineType[LineType["RESISTANCE"] = 2] = "RESISTANCE";
})(LineType || (LineType = {}));
export var MarketState;
(function (MarketState) {
    MarketState[MarketState["Open"] = 0] = "Open";
    MarketState[MarketState["Closed"] = 1] = "Closed";
})(MarketState || (MarketState = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibXQ0LXR5cGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL210NC10eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7S0FFSztBQUNMLE1BQU0sQ0FBTixJQUFZLEtBc0JYO0FBdEJELFdBQVksS0FBSztJQUNmLHNDQUE2QixDQUFBO0lBQzdCLHdCQUFlLENBQUE7SUFDZix3QkFBZSxDQUFBO0lBQ2Ysd0NBQStCLENBQUE7SUFDL0IsMEJBQWlCLENBQUE7SUFDakIsc0NBQTZCLENBQUE7SUFDN0Isc0JBQWEsQ0FBQTtJQUNiLDBDQUFpQyxDQUFBO0lBQ2pDLHdCQUFlLENBQUE7SUFDZixzQ0FBNkIsQ0FBQTtJQUM3QixzQ0FBNkIsQ0FBQTtJQUM3Qix3Q0FBK0IsQ0FBQTtJQUMvQiwwQ0FBaUMsQ0FBQTtJQUNqQyxzREFBNkMsQ0FBQTtJQUM3Qyw0REFBbUQsQ0FBQTtJQUNuRCwwREFBaUQsQ0FBQTtJQUNqRCx3REFBK0MsQ0FBQTtJQUMvQyw0QkFBbUIsQ0FBQTtJQUNuQiwwQkFBaUIsQ0FBQTtJQUNqQiw0Q0FBbUMsQ0FBQTtJQUNuQyxzREFBNkMsQ0FBQTtBQUMvQyxDQUFDLEVBdEJXLEtBQUssS0FBTCxLQUFLLFFBc0JoQjtBQUVELE1BQU0sQ0FBTixJQUFZLE9BVVg7QUFWRCxXQUFZLE9BQU87SUFDakIsMEJBQWUsQ0FBQTtJQUNmLGtDQUF1QixDQUFBO0lBQ3ZCLHNDQUEyQixDQUFBO0lBQzNCLG9DQUF5QixDQUFBO0lBQ3pCLHNDQUEyQixDQUFBO0lBQzNCLGdEQUFxQyxDQUFBO0lBQ3JDLHdDQUE2QixDQUFBO0lBQzdCLGtDQUF1QixDQUFBO0lBQ3ZCLHdEQUE2QyxDQUFBO0FBQy9DLENBQUMsRUFWVyxPQUFPLEtBQVAsT0FBTyxRQVVsQjtBQUVELE1BQU0sQ0FBTixJQUFZLGFBS1g7QUFMRCxXQUFZLGFBQWE7SUFDdkIsdURBQXNDLENBQUE7SUFDdEMsNERBQTJDLENBQUE7SUFDM0Msb0RBQW1DLENBQUE7SUFDbkMsZ0RBQStCLENBQUE7QUFDakMsQ0FBQyxFQUxXLGFBQWEsS0FBYixhQUFhLFFBS3hCO0FBRUQsTUFBTSxDQUFOLElBQVksU0FJWDtBQUpELFdBQVksU0FBUztJQUNuQixtREFBYSxDQUFBO0lBQ2IscUNBQU0sQ0FBQTtJQUNOLHlDQUFRLENBQUE7QUFDVixDQUFDLEVBSlcsU0FBUyxLQUFULFNBQVMsUUFJcEI7QUFFRCxNQUFNLENBQU4sSUFBWSxZQUlYO0FBSkQsV0FBWSxZQUFZO0lBQ3RCLHlEQUFhLENBQUE7SUFDYixxREFBVyxDQUFBO0lBQ1gsMkRBQWMsQ0FBQTtBQUNoQixDQUFDLEVBSlcsWUFBWSxLQUFaLFlBQVksUUFJdkI7QUFFRCxJQUFLLFFBSUo7QUFKRCxXQUFLLFFBQVE7SUFDWCxpREFBYSxDQUFBO0lBQ2IsNkNBQVcsQ0FBQTtJQUNYLG1EQUFjLENBQUE7QUFDaEIsQ0FBQyxFQUpJLFFBQVEsS0FBUixRQUFRLFFBSVo7QUF1VkQsTUFBTSxDQUFOLElBQVksV0FHWDtBQUhELFdBQVksV0FBVztJQUNyQiw2Q0FBUSxDQUFBO0lBQ1IsaURBQVUsQ0FBQTtBQUNaLENBQUMsRUFIVyxXQUFXLEtBQVgsV0FBVyxRQUd0QiJ9